import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { Category, ClientReportHead } from "../report";
import { useDispatch, useSelector } from "react-redux";
import { getClientReportById, getClientSummary } from "../../services";
import { useEffect } from "react";
import { toggle } from "../../redux";

const FitnessReportPreviewsDetailed = () => {
  const { clientId } = useParams();
  const { report } = useSelector((state) => state.client);
  const { summary } = useSelector((state) => state.client);
   const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  useEffect(() => {
    getClientSummary();
  }, []);

  useEffect(() => {
    getClientReportById(clientId);
  }, [clientId]);
const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  return (
    <div onClick={handleMainContainerClick}>
      <Navbar />
      <ClientReportHead report={report} />
      <Category summary={summary} clientId={clientId}/>
    </div>
  );
};

export default FitnessReportPreviewsDetailed;
